document.querySelector('.menu-toggle')?.addEventListener('click',function(){const m=document.getElementById('mobile-menu');m.hidden=!m.hidden;this.setAttribute('aria-expanded',String(!m.hidden));});
document.querySelectorAll('[data-product-url]').forEach(b=>b.addEventListener('click',()=>{location.href=b.dataset.productUrl;}));
document.querySelector('.dialog-close')?.addEventListener('click',()=>document.getElementById('photo-dialog').close());
document.querySelectorAll('.product-form input[name="id"]').forEach(r=>r.addEventListener('change',()=>{const b=document.getElementById('add-product');b.disabled=false;b.textContent='バッグに追加';const url=new URL(location.href);url.searchParams.set('variant',r.value);history.replaceState({},'',url);}));
const photoButtons = [...document.querySelectorAll('[data-photo]')];
const stage = document.querySelector('.gallery-stage');
if (stage && photoButtons.length) {
  const original = document.getElementById('enlarge-photo');
  const track = document.createElement('div');
  track.className = 'gallery-track';
  track.setAttribute('aria-label', '商品画像');
  let current = 0;
  let touchStart = null;
  let dragged = false;
  const slides = photoButtons.map((button, index) => {
    const slide = index === 0 ? original : original.cloneNode(true);
    if (index) { slide.removeAttribute('id'); slide.querySelector('img').removeAttribute('id'); }
    slide.className = 'gallery-slide';
    slide.type = 'button';
    const image = slide.querySelector('img');
    image.removeAttribute('srcset');
    image.src = button.dataset.photo;
    image.alt = button.dataset.label;
    image.loading = index < 2 ? 'eager' : 'lazy';
    image.draggable = false;
    slide.addEventListener('click', event => {
      if (dragged) { event.preventDefault(); return; }
      const zoom = document.getElementById('zoom-photo');
      zoom.src = image.src; zoom.alt = image.alt;
      document.getElementById('photo-dialog').showModal();
    });
    track.append(slide);
    return slide;
  });
  const loop = slides.length > 1;
  if (loop) {
    const clone = slide => {
      const copy = slide.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelector('img').removeAttribute('id');
      copy.querySelector('img').loading = 'eager';
      copy.tabIndex = -1;
      copy.setAttribute('aria-hidden', 'true');
      copy.addEventListener('click', event => {
        if (dragged) { event.preventDefault(); return; }
        slide.click();
      });
      return copy;
    };
    track.prepend(clone(slides[slides.length - 1]));
    track.append(clone(slides[0]));
  }
  const offset = loop ? 1 : 0;
  const go = (index, behavior = 'instant') => track.scrollTo({left: (index + offset) * track.clientWidth, behavior});
  stage.replaceChildren(track);
  go(0);
  const update = index => {
    current = index;
    const caption = document.getElementById('model-caption');
    if (caption) caption.hidden = index < 2 || index > 5;
    document.getElementById('photo-label').textContent = photoButtons[index].dataset.label;
    document.getElementById('photo-counter').textContent = `${index + 1} / ${slides.length}`;
    photoButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
  };
  photoButtons.forEach((button, index) => button.addEventListener('click', () => {
    go(index, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
  }));
  let settleTimer;
  let touching = false;
  const settle = () => {
    if (touching || !track.clientWidth) return;
    const position = Math.round(track.scrollLeft / track.clientWidth);
    if (loop && (position === 0 || position === slides.length + 1)) go(current);
  };
  track.addEventListener('scroll', () => {
    if (!track.clientWidth) return;
    const index = Math.round(track.scrollLeft / track.clientWidth) - offset;
    update((index + slides.length) % slides.length);
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 160);
  }, {passive:true});
  track.addEventListener('scrollend', settle);
  track.addEventListener('touchend', () => { touching = false; settleTimer = setTimeout(settle, 160); }, {passive:true});
  track.addEventListener('touchcancel', () => { touching = false; settle(); }, {passive:true});
  track.addEventListener('touchstart', event => { touching = true; clearTimeout(settleTimer); dragged = false; touchStart = event.touches[0]; }, {passive:true});
  track.addEventListener('touchmove', event => {
    if (touchStart && (Math.abs(event.touches[0].clientX - touchStart.clientX) > 8 || Math.abs(event.touches[0].clientY - touchStart.clientY) > 8)) dragged = true;
  }, {passive:true});
  track.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const next = (current + (event.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length;
    go(next);
    slides[next].focus({preventScroll:true});
  });
  new ResizeObserver(() => go(current)).observe(track);
}

